<template>
  <div class="hello">
    <AboutHome></AboutHome>
    <AboutOur></AboutOur>
    <AboutOurThree></AboutOurThree>
        <!--<div class="carousel-wrap">
          <div class="carousel-cooperate">
            <h2>我们的合作机构</h2>
          </div>
          <div class="carousel-cooperate-list">
            <img v-for="(v,index) in cooperateList" :key="index" :src="v.cooperateUrl">
          </div>
        </div>-->
  </div>
</template>

<script>
  import AboutOur from "../components/AboutOur";
  import AboutOurThree from "../components/AboutOurThree";
  import AboutHome from "../pages/Home";


  export default {
    name: 'About',
    components: {
      AboutOur,AboutOurThree,AboutHome
    },
    data() {
      return {
        cooperateList: [
          {cooperateUrl: require('../assets/hotel1.png')},
          {cooperateUrl: require('../assets/hotel2.png')},
          {cooperateUrl: require('../assets/hotel3.png')},
          {cooperateUrl: require('../assets/logo.png')}
        ]
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    /*line-height: 400px;*/
    margin: 0;
  }
  .carousel-wrap {
    width: 100%;
    /* height: 500px; */
    /* display: inline-block; */
  }

  .carousel-cooperate-list {
    display: flex;
    width: 80%;
    height: 300px;
    margin: 0 auto;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .carousel-cooperate-list > img {
    width: 25%;
    height: 120px;
    margin: 10px 20px;
  }

  .carousel-text > h1 {
    line-height: 50px;
  }

  .carousel-text > p {
    line-height: 30px;
  }

  .carousel-code img {
    width: 150px;
    height: 150px;
  }

  .carousel-cooperate > h2 {
    line-height: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/About.vue